import React from 'react';
import PropertyForm from '../../components/property/PropertyForm';

function PropertyFormPage() {
  return (
    <div className="py-6 px-4 sm:px-6 lg:px-8">
      <PropertyForm />
    </div>
  );
}

export default PropertyFormPage; 